"use strict";

// Start namespace
var pyzel = {};

const endpoint = 'https://pyzeleurope.shaperbuddy.com/api/v1';
//const endpoint = 'https://pyzeleurope.shaperbuddy.com/api/v1/';

//console.log( endpoint );

// Plugins
/*!
 * Lightbox for Bootstrap 3 by @ashleydw
 * https://github.com/ashleydw/lightbox
 *
 * License: https://github.com/ashleydw/lightbox/blob/master/LICENSE
 */
(function(){"use strict";var a,b;a=jQuery,b=function(b,c){var d,e,f;return this.options=a.extend({title:null,footer:null,remote:null},a.fn.ekkoLightbox.defaults,c||{}),this.$element=a(b),d="",this.modal_id=this.options.modal_id?this.options.modal_id:"ekkoLightbox-"+Math.floor(1e3*Math.random()+1),f='<div class="modal-header"'+(this.options.title||this.options.always_show_close?"":' style="display:none"')+'><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">'+(this.options.title||"&nbsp;")+"</h4></div>",e='<div class="modal-footer"'+(this.options.footer?"":' style="display:none"')+">"+this.options.footer+"</div>",a(document.body).append('<div id="'+this.modal_id+'" class="ekko-lightbox modal fade" tabindex="-1"><div class="modal-dialog"><div class="modal-content">'+f+'<div class="modal-body"><div class="ekko-lightbox-container"><div></div></div></div>'+e+"</div></div></div>"),this.modal=a("#"+this.modal_id),this.modal_dialog=this.modal.find(".modal-dialog").first(),this.modal_content=this.modal.find(".modal-content").first(),this.modal_body=this.modal.find(".modal-body").first(),this.modal_header=this.modal.find(".modal-header").first(),this.modal_footer=this.modal.find(".modal-footer").first(),this.lightbox_container=this.modal_body.find(".ekko-lightbox-container").first(),this.lightbox_body=this.lightbox_container.find("> div:first-child").first(),this.showLoading(),this.modal_arrows=null,this.border={top:parseFloat(this.modal_dialog.css("border-top-width"))+parseFloat(this.modal_content.css("border-top-width"))+parseFloat(this.modal_body.css("border-top-width")),right:parseFloat(this.modal_dialog.css("border-right-width"))+parseFloat(this.modal_content.css("border-right-width"))+parseFloat(this.modal_body.css("border-right-width")),bottom:parseFloat(this.modal_dialog.css("border-bottom-width"))+parseFloat(this.modal_content.css("border-bottom-width"))+parseFloat(this.modal_body.css("border-bottom-width")),left:parseFloat(this.modal_dialog.css("border-left-width"))+parseFloat(this.modal_content.css("border-left-width"))+parseFloat(this.modal_body.css("border-left-width"))},this.padding={top:parseFloat(this.modal_dialog.css("padding-top"))+parseFloat(this.modal_content.css("padding-top"))+parseFloat(this.modal_body.css("padding-top")),right:parseFloat(this.modal_dialog.css("padding-right"))+parseFloat(this.modal_content.css("padding-right"))+parseFloat(this.modal_body.css("padding-right")),bottom:parseFloat(this.modal_dialog.css("padding-bottom"))+parseFloat(this.modal_content.css("padding-bottom"))+parseFloat(this.modal_body.css("padding-bottom")),left:parseFloat(this.modal_dialog.css("padding-left"))+parseFloat(this.modal_content.css("padding-left"))+parseFloat(this.modal_body.css("padding-left"))},this.modal.on("show.bs.modal",this.options.onShow.bind(this)).on("shown.bs.modal",function(a){return function(){return a.modal_shown(),a.options.onShown.call(a)}}(this)).on("hide.bs.modal",this.options.onHide.bind(this)).on("hidden.bs.modal",function(b){return function(){return b.gallery&&a(document).off("keydown.ekkoLightbox"),b.modal.remove(),b.options.onHidden.call(b)}}(this)).modal("show",c),this.modal},b.prototype={modal_shown:function(){var b;return this.options.remote?(this.gallery=this.$element.data("gallery"),this.gallery&&("document.body"===this.options.gallery_parent_selector||""===this.options.gallery_parent_selector?this.gallery_items=a(document.body).find('*[data-gallery="'+this.gallery+'"]'):this.gallery_items=this.$element.parents(this.options.gallery_parent_selector).first().find('*[data-gallery="'+this.gallery+'"]'),this.gallery_index=this.gallery_items.index(this.$element),a(document).on("keydown.ekkoLightbox",this.navigate.bind(this)),this.options.directional_arrows&&this.gallery_items.length>1&&(this.lightbox_container.append('<div class="ekko-lightbox-nav-overlay"><a href="#" class="'+this.strip_stops(this.options.left_arrow_class)+'"></a><a href="#" class="'+this.strip_stops(this.options.right_arrow_class)+'"></a></div>'),this.modal_arrows=this.lightbox_container.find("div.ekko-lightbox-nav-overlay").first(),this.lightbox_container.find("a"+this.strip_spaces(this.options.left_arrow_class)).on("click",function(a){return function(b){return b.preventDefault(),a.navigate_left()}}(this)),this.lightbox_container.find("a"+this.strip_spaces(this.options.right_arrow_class)).on("click",function(a){return function(b){return b.preventDefault(),a.navigate_right()}}(this)))),this.options.type?"image"===this.options.type?this.preloadImage(this.options.remote,!0):"youtube"===this.options.type&&(b=this.getYoutubeId(this.options.remote))?this.showYoutubeVideo(b):"vimeo"===this.options.type?this.showVimeoVideo(this.options.remote):"instagram"===this.options.type?this.showInstagramVideo(this.options.remote):"url"===this.options.type?this.loadRemoteContent(this.options.remote):"video"===this.options.type?this.showVideoIframe(this.options.remote):this.error('Could not detect remote target type. Force the type using data-type="image|youtube|vimeo|instagram|url|video"'):this.detectRemoteType(this.options.remote)):this.error("No remote target given")},strip_stops:function(a){return a.replace(/\./g,"")},strip_spaces:function(a){return a.replace(/\s/g,"")},isImage:function(a){return a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)},isSwf:function(a){return a.match(/\.(swf)((\?|#).*)?$/i)},getYoutubeId:function(a){var b;return b=a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/),b&&11===b[2].length?b[2]:!1},getVimeoId:function(a){return a.indexOf("vimeo")>0?a:!1},getInstagramId:function(a){return a.indexOf("instagram")>0?a:!1},navigate:function(a){if(a=a||window.event,39===a.keyCode||37===a.keyCode){if(39===a.keyCode)return this.navigate_right();if(37===a.keyCode)return this.navigate_left()}},navigateTo:function(b){var c,d;return 0>b||b>this.gallery_items.length-1?this:(this.showLoading(),this.gallery_index=b,this.$element=a(this.gallery_items.get(this.gallery_index)),this.updateTitleAndFooter(),d=this.$element.attr("data-remote")||this.$element.attr("href"),this.detectRemoteType(d,this.$element.attr("data-type")||!1),this.gallery_index+1<this.gallery_items.length&&(c=a(this.gallery_items.get(this.gallery_index+1),!1),d=c.attr("data-remote")||c.attr("href"),"image"===c.attr("data-type")||this.isImage(d))?this.preloadImage(d,!1):void 0)},navigate_left:function(){return 1!==this.gallery_items.length?(0===this.gallery_index?this.gallery_index=this.gallery_items.length-1:this.gallery_index--,this.options.onNavigate.call(this,"left",this.gallery_index),this.navigateTo(this.gallery_index)):void 0},navigate_right:function(){return 1!==this.gallery_items.length?(this.gallery_index===this.gallery_items.length-1?this.gallery_index=0:this.gallery_index++,this.options.onNavigate.call(this,"right",this.gallery_index),this.navigateTo(this.gallery_index)):void 0},detectRemoteType:function(a,b){var c;return b=b||!1,"image"===b||this.isImage(a)?(this.options.type="image",this.preloadImage(a,!0)):"youtube"===b||(c=this.getYoutubeId(a))?(this.options.type="youtube",this.showYoutubeVideo(c)):"vimeo"===b||(c=this.getVimeoId(a))?(this.options.type="vimeo",this.showVimeoVideo(c)):"instagram"===b||(c=this.getInstagramId(a))?(this.options.type="instagram",this.showInstagramVideo(c)):"video"===b?(this.options.type="video",this.showVideoIframe(a)):(this.options.type="url",this.loadRemoteContent(a))},updateTitleAndFooter:function(){var a,b,c,d;return c=this.modal_content.find(".modal-header"),b=this.modal_content.find(".modal-footer"),d=this.$element.data("title")||"",a=this.$element.data("footer")||"",d||this.options.always_show_close?c.css("display","").find(".modal-title").html(d||"&nbsp;"):c.css("display","none"),a?b.css("display","").html(a):b.css("display","none"),this},showLoading:function(){return this.lightbox_body.html('<div class="modal-loading">'+this.options.loadingMessage+"</div>"),this},showYoutubeVideo:function(a){var b,c,d;return c=null!=this.$element.attr("data-norelated")||this.options.no_related?"&rel=0":"",d=this.checkDimensions(this.$element.data("width")||560),b=d/(560/315),this.showVideoIframe("//www.youtube.com/embed/"+a+"?badge=0&autoplay=1&html5=1"+c,d,b)},showVimeoVideo:function(a){var b,c;return c=this.checkDimensions(this.$element.data("width")||560),b=c/(500/281),this.showVideoIframe(a+"?autoplay=1",c,b)},showInstagramVideo:function(a){var b,c;return c=this.checkDimensions(this.$element.data("width")||612),this.resize(c),b=c+80,this.lightbox_body.html('<iframe width="'+c+'" height="'+b+'" src="'+this.addTrailingSlash(a)+'embed/" frameborder="0" allowfullscreen></iframe>'),this.options.onContentLoaded.call(this),this.modal_arrows?this.modal_arrows.css("display","none"):void 0},showVideoIframe:function(a,b,c){return c=c||b,this.resize(b),this.lightbox_body.html('<div class="embed-responsive embed-responsive-16by9"><iframe width="'+b+'" height="'+c+'" src="'+a+'" frameborder="0" allowfullscreen class="embed-responsive-item"></iframe></div>'),this.options.onContentLoaded.call(this),this.modal_arrows&&this.modal_arrows.css("display","none"),this},loadRemoteContent:function(b){var c,d;return d=this.$element.data("width")||560,this.resize(d),c=this.$element.data("disableExternalCheck")||!1,c||this.isExternal(b)?(this.lightbox_body.html('<iframe width="'+d+'" height="'+d+'" src="'+b+'" frameborder="0" allowfullscreen></iframe>'),this.options.onContentLoaded.call(this)):this.lightbox_body.load(b,a.proxy(function(a){return function(){return a.$element.trigger("loaded.bs.modal")}}(this))),this.modal_arrows&&this.modal_arrows.css("display","none"),this},isExternal:function(a){var b;return b=a.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/),"string"==typeof b[1]&&b[1].length>0&&b[1].toLowerCase()!==location.protocol?!0:"string"==typeof b[2]&&b[2].length>0&&b[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"),"")!==location.host},error:function(a){return this.lightbox_body.html(a),this},preloadImage:function(b,c){var d;return d=new Image,null!=c&&c!==!0||(d.onload=function(b){return function(){var c;return c=a("<img />"),c.attr("src",d.src),c.addClass("img-responsive"),b.lightbox_body.html(c),b.modal_arrows&&b.modal_arrows.css("display","block"),c.load(function(){return b.options.scale_height?b.scaleHeight(d.height,d.width):b.resize(d.width),b.options.onContentLoaded.call(b)})}}(this),d.onerror=function(a){return function(){return a.error("Failed to load image: "+b)}}(this)),d.src=b,d},scaleHeight:function(b,c){var d,e,f,g,h,i;return g=this.modal_header.outerHeight(!0)||0,f=this.modal_footer.outerHeight(!0)||0,this.modal_footer.is(":visible")||(f=0),this.modal_header.is(":visible")||(g=0),d=this.border.top+this.border.bottom+this.padding.top+this.padding.bottom,h=parseFloat(this.modal_dialog.css("margin-top"))+parseFloat(this.modal_dialog.css("margin-bottom")),i=a(window).height()-d-h-g-f,e=Math.min(i/b,1),this.modal_dialog.css("height","auto").css("max-height",i),this.resize(e*c)},resize:function(b){var c;return c=b+this.border.left+this.padding.left+this.padding.right+this.border.right,this.modal_dialog.css("width","auto").css("max-width",c),this.lightbox_container.find("a").css("line-height",function(){return a(this).parent().height()+"px"}),this},checkDimensions:function(a){var b,c;return c=a+this.border.left+this.padding.left+this.padding.right+this.border.right,b=document.body.clientWidth,c>b&&(a=this.modal_body.width()),a},close:function(){return this.modal.modal("hide")},addTrailingSlash:function(a){return"/"!==a.substr(-1)&&(a+="/"),a}},a.fn.ekkoLightbox=function(c){return this.each(function(){var d;return d=a(this),c=a.extend({remote:d.attr("data-remote")||d.attr("href"),gallery_parent_selector:d.attr("data-parent"),type:d.attr("data-type")},c,d.data()),new b(this,c),this})},a.fn.ekkoLightbox.defaults={gallery_parent_selector:"document.body",left_arrow_class:".glyphicon .glyphicon-chevron-left",right_arrow_class:".glyphicon .glyphicon-chevron-right",directional_arrows:!0,type:null,always_show_close:!0,no_related:!1,scale_height:!0,loadingMessage:"Loading...",onShow:function(){},onShown:function(){},onHide:function(){},onHidden:function(){},onNavigate:function(){},onContentLoaded:function(){}}}).call(this);
/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				return (document.cookie = [
					key, '=', value,
					attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					attributes.path ? '; path=' + attributes.path : '',
					attributes.domain ? '; domain=' + attributes.domain : '',
					attributes.secure ? '; secure' : ''
				].join(''));
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }


        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }

        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick',
                '*:not(.slick-arrow)', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this;
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        _.$slideTrack.attr('role', 'listbox');

        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
            $(this).attr({
                'role': 'option',
                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
            });
        });

        if (_.$dots !== null) {
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                $(this).attr({
                    'role': 'presentation',
                    'aria-selected': 'false',
                    'aria-controls': 'navigation' + _.instanceUid + i + '',
                    'id': 'slick-slide' + _.instanceUid + i + ''
                });
            })
                .first().attr('aria-selected', 'true').end()
                .find('button').attr('role', 'button').end()
                .closest('div').attr('role', 'toolbar');
        }
        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {
                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            _.setPosition();

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {

                    _.$slides
                        .slice(index - centerOffset, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand') {
            _.lazyLoad();
        }

    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.setSlideClasses(index);
            _.asNavFor(index);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(
                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();

        if (swipeDirection === 'vertical') {
            return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                .removeClass('slick-active')
                .attr('aria-hidden', 'true');

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active')
                .attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));


// Site components
/**
 * Converts IMG tags with SVG images to inline SVG. This way the SVG is cached by the browser and we can manipulate it by CSS
 *
 * @return {void}
 */
pyzel.convertToSVG = function() {

	$('img[src$=".svg"]').each(function() {
		var img = $(this);
		var imgURL = img.attr('src');
		var attributes = img.prop("attributes");

		$.get(imgURL, function(data) {
			// Get the SVG tag, ignore the rest
			var svg = jQuery(data).find('svg');

			// Remove any invalid XML tags
			svg = svg.removeAttr('xmlns:a');

			// Loop through IMG attributes and apply on SVG
			$.each(attributes, function() {
				svg.attr(this.name, this.value);
			});

			// Replace IMG with SVG
			img.replaceWith(svg);
		}, 'xml');
	});

};
// Extend namespace by creating a new object
pyzel.fullwidthVideo = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.fullwidthVideo.init = function() {

	$('.js-fullwidth-video-play').click(function(e){
		e.preventDefault();
		pyzel.fullwidthVideo.play( $(this) );
	});

};



/**
 * Play video
 *
 * @param {object} el Element clicked
 *
 * @return {void}
 */
pyzel.fullwidthVideo.play = function(el) {

	var
		videoPlaceholder = $('.js-fullwidth-video-placeholder'),
		sliderHeight = el.outerHeight()
	;

	// Reset CSS of placeholder
	videoPlaceholder.css('display', 'none');
	videoPlaceholder.css('position', 'absolute');
	videoPlaceholder.css('width', '100%');
	videoPlaceholder.css('height', '100%');
	videoPlaceholder.css('top', 0);
	videoPlaceholder.css('left', 0);
	videoPlaceholder.css('z-index', 1050); // Because of bootstrap fixed to top menu

	// Show video placeholder and scroll to top
	videoPlaceholder.fadeIn();
	$('html, body').animate({
		scrollTop: videoPlaceholder.offset().top
	}, 'slow');

	// Set iframe inside video placeholder and play video
	videoPlaceholder.html('<iframe src="https://player.vimeo.com/video/'+ el.data('vimeo-id') +'?autoplay=1&api=1&player_id=fullwidth-video-iframe" id="fullwidth-video-iframe" width="100%" height="' + $(window.top).height() + '" frameborder="0" allowfullscreen></iframe>');

	// Access the iframe so we can add events
	var iframe = $('#fullwidth-video-iframe')[0];
	var player = $f(iframe);

	// When the player is ready, add listeners
	player.addEvent('ready', function() {

		console.log('player is ready');
		
		// buggy on local version? maybe some css issue?
		setTimeout(function(){

			$(window).on('scroll', function() {
				/*
				videoPlaceholder.css('height', sliderHeight);
				videoPlaceholder.css('top', 'auto');
				videoPlaceholder.css('left', 'auto');
				videoPlaceholder.css('z-index', 9);
				$('#fullwidth-video-iframe').css('height', sliderHeight);
				*/

				// force finish on scroll - testing
				//onFinish();
				//console.log('on finish?');

			});

		}, 2000);
		

		player.addEvent('finish', onFinish);
	});

	function onFinish() {

		console.log('on finish was called');

		videoPlaceholder.fadeOut(100);

		//$(window).off('scroll');

		// trying to fix a layout bug that appears after the video is added.
		pyzel.quiver.init();

	}


};
// global helpers


pyzel.helpers = {

	/**
	 * Read form the array and returns comma separated values
	 *
	 */
	skill_level: function ( levels ){	

		let levels_array = [];

		$.each( levels, ( k, i ) =>{ 
			
			levels_array.push( i.name );

		})

		return levels_array.join(', ');

	},

	/**
	 * Read form the array and returns comma separated values
	 * a more abstract function than the one above
	 * assumes that there is a "name"
	 * 20.03.2017: now accepts a custom key name
	 * 
	 */
	csv: function ( array, key_name ){		

		let output = [];

		$.each( array, ( k, i ) =>{ 					

			if( ! key_name )
				output.push( i.name );
			else				
				output.push( i[key_name] );				

		})

		return output.join(', ');

	},	


	/**
	 * Get the tails, rails and fin setup name
	 *
	 */
	board_features: function( features ){

		//return 'feature name';
		//console.log( id_feature );
		//console.log( array );

		let board_features = [];

	    //$.each( data[0].features, function( key, value ){
	    $.each( features, ( k, i ) => {

	        if( i.name == 'Stock tail' ){
	            board_features['tail'] = i.value;
	        }else if( i.name == 'Stock Rail' ){
	            board_features['rails']  = i.value;
	        }else if( i.name == 'Stock fin setup' ){
	            board_features['fins']  = i.value;
	        }    

        })

        return board_features;   

	},

	/**
	 * Formats yy-mm-dd to dd / mm / yy
	 *
	 */
	format_date: function ( date ){

		let date_array = date.split( '-' );

		return date_array[2]+' / '+date_array[1]+' / '+date_array[0];

	},


	/**
	 * Formats string to web safe name
	 *
	 */
	 safe_name: function ( string ){

	 	if( typeof string != 'string' ){
	 		console.log( string +' is not a string');
	 	}


	 	//console.log( 'safe_name for: '+string );
	 	//return false;
		
		return string.replace(/\s+/g, '-').toLowerCase();		
		//string = string.replace(/\s+/g, '-');
		//return string.toLowerCase();

	},

	/**
	 * Gets the video returns the id and image
	 * for vimeo at the moment
 	 *
	 */
	get_video_details: function( video ){

		console.log( 'get_video_details' );

		//alert( video );

		//var dfd = $.Deferred();

		// can´t create a vimeo app at the moment..

		let video_details = [];

		console.log( video );
		//console.log( 'video.url: '+video.url );

		let url_array = video.url.split('/');

		//console.log( url_array );

		video_details['id'] = url_array[ url_array.length - 1 ];

		// does not work
		
		// user pedro.silva@shaperbuddy.com
		// app get-video-images

		//return $.when(

			$.ajax({

				url: 'https://api.vimeo.com/oauth/authorize/client',
				method: 'post',
				data: {

					grant_type: "client_credentials"

				},
				/*
				headers: {
	    			//"Authorization : basic " + base64( '84fe85942b9796e7be2d33a355b6144fbf728d3a' + ":" + '7CyQ7UktgdyememDwWkv3Jfa/vbNftNEsOP0WVhOG5RG4k/+Z+8xZ3AgU4fV6qPBuLriVsEL9YoblZYgBU8MJrUvVUcxxseVZ+nQtyc2D/8XBE61l09nyDNcTPVkYYyA')
	    			"Authorization : basic " + base64(client_id + ":" + client_secret)
	  			}
	  			*/
	  			beforeSend: function (xhr) {
	    			xhr.setRequestHeader ("Authorization", "Basic " + btoa('84fe85942b9796e7be2d33a355b6144fbf728d3a'+ ":" + '7CyQ7UktgdyememDwWkv3Jfa/vbNftNEsOP0WVhOG5RG4k/+Z+8xZ3AgU4fV6qPBuLriVsEL9YoblZYgBU8MJrUvVUcxxseVZ+nQtyc2D/8XBE61l09nyDNcTPVkYYyA' ));
				},			

			}).done( function( r ){

				console.log( r.access_token );

				let token = r.access_token;

				//return $.when(

					$.ajax({

						url: 'https://api.vimeo.com/videos/'+video_details['id']+'/pictures',
						method: 'get',
						beforeSend: function(xhr){
		            		xhr.setRequestHeader('Authorization', 'bearer '+token+'');
		            	}

					}).done( r => {

						console.log('we got images from vimeo:');
						console.log( r.data[0].sizes[5].link );
						video_details['image'] = r.data[0].sizes[5].link;

						//return video_details;

						//dfd.resolve();

						return video_details;

					})

				//)	

			}).fail( function( r ){

				console.log( r );

			})		
		
		//)
		//return video_details;

		//return dfd.promise();

	},

}
// instagram

// Extend namespace by creating a new object
pyzel.instagram = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.instagram.init = function( user_id ) {		

	$.ajax({
	    	
	    type: "GET",
	    dataType: "jsonp",
	    cache: false,
	    //this is the token of pictures feed app of user @pedrosilvashaperbuddy
	    //url: "https://api.instagram.com/v1/users/23630467/media/recent/?access_token=3314912590.dd3641f.b0a044bae2bd4e8688db295404f4d42d"
	    //this is the token of Smash Balloon WordPress Plugin App of user @pedrosilvashaperbuddy ( hack mode on! )
	    url: "https://api.instagram.com/v1/users/"+user_id+"/media/recent/?access_token=3314912590.3a81a9f.b1e95453cb22446e836e2949ade741ec"
	    // get user id using this: https://smashballoon.com/instagram-feed/find-instagram-user-id/

	}).done( function( r ){
	    
	    let html = '';
	    let photos = 6;
	    //let loops = 0;
		let xs_class = 'col-xs-6';	    


	    //$.each( r.data, function(){
	    $.each( r.data, (key, value) =>{

	        //loops++;
	        
	        if( key < photos ){

	        	if( key > 3 ) xs_class = 'hidden-xs';
	         
	            html += 
	                
	            `<div class="col-sm-2 ${ xs_class }">

	                <a href="${ value.link }" target="_blank">

	                    <img src="${ value.images.low_resolution.url }" class="img-responsive">

	                </a>

	            </div>`;            
	            
	        }
	        
	        return;        
	           
	    })
	    
	    $('#instagram-feed').html( html );
	    
	});


};

// hackish mode..
// does not work with ajax, must be with PHP..
/*
pyzel.instagram.get_user_id = ( url )=>{

	//console.log( username );
	
	$.ajax({

		url: url+'/?__a=1',		
		//dataType: 'jsonp',
		//jsonp: '',
		crossOrigin: true,

	}).done( (r)=>{

		console.log( r );

	})	

}

pyzel.instagram.get_user_id('https://www.instagram.com/anastasiaashley');
*/
// Extend namespace by creating a new object
pyzel.maps = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.maps.init = function() {

	$('.map').click(function(){
		$(this).find('iframe').addClass('clicked')
	}).mouseleave(function(){
		$(this).find('iframe').removeClass('clicked')
	});

};
// Extend namespace by creating a new object
pyzel.menuMobile = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.menuMobile.init = function() {

	// Show the menu
	$('.js-menu-mobile-toggle').on('click', function(){
		pyzel.menuMobile.toggle();
	});

};



/**
 * Show or hide the menu
 *
 * @return void
 */
pyzel.menuMobile.toggle = function() {

	var menu = $('.js-menu-mobile');

	if ( menu.is(':visible') ) {
		$('.js-submenu').hide();
		menu.hide();
		$('.js-menu-mobile-toggle').removeClass('open');
	} else {
		menu.show();
		$('.js-menu-mobile-toggle').addClass('open');
	}

};
// nested deferreds

pyzel.nested = {

}

//main();

pyzel.newsletter = {

    subscription: $( function(){

        $('#subscribe-newsletter-btn').on('click', e =>{
            
            e.preventDefault();                    
            
            let name = $('#subscribe-newsletter-form #name').val();    
            let email = $('#subscribe-newsletter-form #email').val();
            
            if( name != '' && /(.+)@(.+){2,}\.(.+){2,}/.test( email ) ){

                $.ajax({

                    url: endpoint+'/subscribers',
                    method: 'post',
                    contentType: 'application/json',
                    dataType: 'json',            
                    data: JSON.stringify( {

                        name, 
                        email                

                    } )

                }).done( r => {                    

                    $('#subscribe-newsletter-form input').fadeOut();

                    $('#subscribe-newsletter-btn').off('click');

                    $('#subscribe-newsletter-btn').html('you are subscribed!').addClass('btn-success disabled');

                }).fail( e => {

                    console.log( e );

                    alert('an error occured while communicating with the server');

                })
                
            }else{
             
                alert('please check invalid fields');
                
                // add some visual feedback - not defined on the design
                //$('#subscribe-newsletter-form #email').parent('.form-group').addClass('has-error');
                
            }        
            
        })

    })

};
// Extend namespace by creating a new object
pyzel.quiver = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.quiver.init = function() {

	if ( $('.js-quiver-image').length ) {
		pyzel.quiver.imageFixed();
	}

};


pyzel.quiver.imageFixed = function() {

	console.log('fixing image');

	var
		elImage = $('.js-quiver-image'),
		elEndScroll = $('.js-quiver-end-scroll'),
		elSurfboardsContainer = $('.js-quiver-surfboards-container')
	;

	console.log( "elImage.offset().top" );
	console.log( elImage.offset().top );


	elImage.affix({
		offset: {
			top: (elImage.offset().top + elImage.outerHeight() - window.innerHeight),
			bottom: function () {
				return (this.bottom = elEndScroll.outerHeight(true))
			}
		}
	});

	elImage.on('affixed.bs.affix', function(){

		//console.log( 'affixed.bs.affix' );

		//$('#quiver-rider-picture').css();

		let dir = '';

		$( window ).on('wheel', ( e )=> {

			let delta = e.originalEvent.deltaY;
		
			if (delta > 0){ 
				console.log( 'down' );
				dir = '+';
			}else{ 
				console.log( 'up' );
				dir = '-';
			}
				
			//console.log('we seem to be scrolling.. or wheeling ( and listenning to it )');
			$('#quiver-rider-picture').stop().animate({'background-position': dir+'=10%' }, 500, 'linear');

			//$('#quiver-rider-picture').animate("-webkit-filter", "hue-rotate("+Math.random() * 360 +"deg)");

		})		

		elSurfboardsContainer.addClass('col-md-offset-6');
	});

	elImage.on('affixed-top.bs.affix', function(){

		//console.log( 'affixed-top.bs.affix' );

		$( window ).off('wheel');

		elSurfboardsContainer.removeClass('col-md-offset-6');

	});

	elImage.on('affixed-bottom.bs.affix', function(){

		//console.log( 'affixed-bottom.bs.affix' );

		$( window ).off('wheel');

		elSurfboardsContainer.removeClass('col-md-offset-6');

	});

};
// Extend namespace by creating a new object
pyzel.sliders = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.sliders.init = function() {

	// Init all the sliders (there's logic in each method to check if the slider actually exists before initiating them)
	//pyzel.sliders.homepageTop();
	//pyzel.sliders.homepageBoards();
	//pyzel.sliders.boardsList();
	//pyzel.sliders.technology();
	//pyzel.sliders.about();
	//pyzel.sliders.surfboardDetails();
	//pyzel.sliders.fullwidthVideo();
	//pyzel.sliders.teamQuiver();

};


/**
 * Homepage, top
 *
 * @return {void}
 */
pyzel.sliders.homepageTop = function() {

	var el = $('.js-homepage-top-slider');

	// Check if slider exists
	if ( el.length ) {

		// Fix so the first slide animates on load
		el.on('init', function(slick){

			el.find('.slick-current').removeClass('slick-active');
			setTimeout( function() {
				el.find('.slick-current').addClass('slick-active');
			}, 5);

		});

		el.slick({
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager inside',
			autoplay: true,
			autoplaySpeed: 7000,
			pauseOnHover: false
		});


	}

};



/**
 * Homepage, boards
 *
 * @return {void}
 */
pyzel.sliders.homepageBoards = function() {

	var el = $('.js-homepage-boards-slider');

	// Check if slider exists
	if ( el.length ) {

		console.log( el );
		//return 0;

		el.slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager',
			autoplay: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});


	}

};


/**
 * Surfboards, list
 *
 * @return {void}
 */
pyzel.sliders.boardsList = function() {

	var el = $('.js-boards-list-slider');

	// Check if slider exists
	if (el.length) {

		// Listener to remove the slider when we are back in desktop view
		pyzel.sliders.boardSliderListener = $(window).on('resize', function(){

			if ( $(window).width() > 768 ) {

				// Remove the slider
				if( el.hasClass('slick-initialized') ) {
					el.slick('unslick');
				}

			} else if ( !el.hasClass('slick-initialized') ) {

				// Reenable the slider
				pyzel.sliders.boardsList();

			}

		});

		// This slider is only enabled in responsive view
		if ( $(window).width() <= 768 ) {

			// Checks if the slider has been initialized
			if ( !el.hasClass('slick-initialized') ) {

				el.slick({
					mobileFirst: true,
					slidesToScroll: 1,
					slidesToShow: 1,
					arrows: false,
					dots: true,
					dotsClass: 'slider-pager',
					autoplay: false,
					responsive: [
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2
							}
						}
					]
				});

			}


		}


	}

};



/**
 * Technology
 *
 * @return {void}
 */
pyzel.sliders.technology = function() {

	var el = $('.js-technology-slider');

	// Check if slider exists
	if ( el.length ) {

		el.slick({
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager inside',
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});


	}

};



/**
 * About
 *
 * @return {void}
 */
pyzel.sliders.about = function() {

	var el = $('.js-about-slider');

	// Check if slider exists
	if ( el.length ) {

		el.slick({
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager inside',
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});


	}

};



/**
 * About
 *
 * @return {void}
 */
pyzel.sliders.surfboardDetails = function() {

	var el = $('.js-surfboard-details-slider');

	// Check if slider exists
	if ( el.length ) {

		el.slick({
			arrows: true,
			dots: true,
			dotsClass: 'slider-pager',
			prevArrow: '<div class="slider-arrows prev"><img src="/images/slider-arrow-prev.png" width="31" height="51" border="0"></div>',
			nextArrow: '<div class="slider-arrows next"><img src="/images/slider-arrow-next.png" width="31" height="51" border="0"></div>',
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});


	}

};



/**
 * Fullwidth videos (used in surfboard details and team details)
 *
 * @return {void}
 */
pyzel.sliders.fullwidthVideo = function() {

	var el = $('.js-fullwidth-video-slider');

	// Check if slider exists
	if ( el.length ) {

		el.slick({
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager inside',
			autoplay: false
		});


	}

};



/**
 * Team, quiver
 *
 * @return {void}
 */
pyzel.sliders.teamQuiver = function() {

	var el = $('.js-slider-quiver');

	// Check if slider exists
	if (el.length) {

		// Listener to remove the slider when we are back in desktop view
		pyzel.sliders.quiverSliderListener = $(window).on('resize', function(){

			if ( $(window).width() > 992 ) {

				// Remove the slider
				if( el.hasClass('slick-initialized') ) {
					el.slick('unslick');
				}

			} else if ( !el.hasClass('slick-initialized') ) {

				// Reenable the slider
				pyzel.sliders.teamQuiver();

			}

		});

		// This slider is only enabled in responsive view
		if ( $(window).width() <= 992 ) {

			// Checks if the slider has been initialized
			if ( !el.hasClass('slick-initialized') ) {

				el.slick({
					mobileFirst: true,
					slidesToScroll: 1,
					slidesToShow: 1,
					arrows: false,
					dots: true,
					dotsClass: 'slider-pager',
					autoplay: false
				});

			}


		}


	}

};
pyzel.social = {

	// searchs for share icons
	// and if they have links, open
	// if not share
	init: //$( 

		()=>{

		//function(){	

			//console.log('searching for share icons');

			//console.log( $('main a.icon') );

			$('main a.icon').on('click', ( e )=>{			
			
				e.preventDefault();
				
				let el = $( e.target );
				//let el = $( e.currentTarget );

				//e.preventDefault();

				//console.log( el.data('url') );

				//console.log( el );
				//return false;

				//if( el.prop('href') != '#' ) return 0;

				//console.log( 'href' );
				//console.log( el.prop('href') );

				//if( el.prop('href') != '#' ) console.log('href != #');

				//if( el.data('url') ) return 0;

				let url = '';

				// if no url is defined, is share current page
				// maybe use href?
				// how will be the "follow"?
				if( el.data('url') ){

					//console.log('a');fo

					url = el.data('url');

					//el.prop('href', url );

					//el.trigger('click');

					window.open( url );

					return 0;

				}else{				

					//console.log('b');					

					let network = el.attr('class').split(' ')[1];

					//console.log( network );

					//console.log( el.data('img') );

					url = window.location.href;	

					pyzel.social[network]( encodeURIComponent( url ), el.data('img'), el.data('txt') );				

				}							

			});

		},

	//),
	
	instagram: ( url )=>{

		// share on insta? think not..
		//console.log('insta yo! '+url);

	},	

	googleplus: ( url )=>{

		window.open('https://plus.google.com/share?url='+url);

	},	

	twitter: ( url )=>{
			
		window.open('https://twitter.com/intent/tweet?text=Pyzel+Surfboards:+'+url);

	},	

	facebook: ( url )=>{

		window.open('https://www.facebook.com/sharer/sharer.php?u='+url);

	},

	pinterest: ( url, img, txt )=>{
	
		//console.log( url );
		//console.log( img );

		// martelate while on dev phase..
		url = 'http://www.pyzelsurfboards.com/';

		// this is supposed to have an image..
		// it could be the one from open graph, but wait..
		window.open('http://pinterest.com/pin/create/link/?url='+url+'&media='+img+'&description=Pyzel%20Surfboards%20-%20'+txt);	

	},

	// makes the icons work on riders and about
	build_links: ( networks )=>{

		//console.log('building social links');
		//console.log( networks );

		$.each( networks, ( k, i )=>{

	 		//console.log( i );

	 		// FB
	 		if( i.id_socialnetwork == 1 ){

	 			$('.icons a.icon.facebook').css('display','inline-block').show().data( 'url', i.url );

	 		// twitter
	 		}else if( i.id_socialnetwork == 2 ){

	 			$('.icons a.icon.twitter').css('display','inline-block').data( 'url', i.url );

			// youtubiu	
	 		}else if( i.id_socialnetwork == 3 ){

	 			$('.icons a.icon.youtube').css('display','inline-block').data( 'url', i.url );	 			

	 		// insta	
	 		}else if( i.id_socialnetwork == 4 ){

	 			$('.icons a.icon.instagram').css('display','inline-block').data( 'url', i.url );

	 			//console.log( i.url );

	 			let instagram_url_array = i.url.split('/');

	 			// filter empty
	 			instagram_url_array = instagram_url_array.filter( n => n );

				//console.log( instagram_url_array );

				//console.log( '@'+instagram_url_array[ instagram_url_array.length - 1 ] );

	 			$('#instagram-name').text( '@'+instagram_url_array[ instagram_url_array.length - 1 ] );

			// vimeo	
	 		}else if( i.id_socialnetwork == 5 ){

	 			$('.icons a.icon.vimeo').css('display','inline-block').data( 'url', i.url );	 		

	 		}else{

	 			console.log('pizel.social.build_links(): icon for this network ('+i.socialnetwork+') does not exist on the GUI');

	 		}

	 	})		

	}

}
// Extend namespace by creating a new object
pyzel.submenus = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.submenus.init = function() {

	// Show the submenu
	$('.js-show-submenu').on('mouseenter', function(){
		pyzel.submenus.show( $(this) );
	});

	// Hide the submenu
	$('.js-hide-submenu').on('mouseenter', function(){
		pyzel.submenus.hide();
	});

	// Hide the submenu
	$('.js-navbar').on('mouseleave', function(){
		pyzel.submenus.hide();
	});


	// Show the submenu
	$('.js-show-submenu').on('click', function(){
		pyzel.submenus.showMobile( $(this) );
	});

	// Hide the submenu
	$('.js-hide-submenu').on('click', function(){
		pyzel.submenus.hideMobile();
	});

};



/**
 * Show the submenu
 *
 * @param {object} el Selected element
 *
 * @return void
 */
pyzel.submenus.show = function(el) {

	// Only runs on desktop version
	if ( !$('.js-menu-mobile-toggle').is(':visible') ) {

		var submenu = el.data('submenu');

		// Just in case a submenu is still visible
		$('.js-submenu ul').hide();
		$('.js-show-submenu').removeClass('arrow');

		// Show the menu options
		$('.js-submenu-' + submenu).show();

		// Insert arrow
		el.addClass('arrow');

		// Animate
		$('.js-submenu').stop().slideDown();

	}

};



/**
 * Hides the submenu
 *
 * @return void
 */
pyzel.submenus.hide = function () {

	// Only runs on desktop version
	if ( !$('.js-menu-mobile-toggle').is(':visible') ) {
		$('.js-submenu').stop().slideUp(function(){
			$('.js-submenu ul').hide();
			$('.js-show-submenu').removeClass('arrow');
		});
	}

};



/**
 * Show the submenu in mobile
 *
 * @param {object} el Selected element
 *
 * @return void
 */
pyzel.submenus.showMobile = function(el) {

	// Only runs on mobile
	if ( $('.js-menu-mobile-toggle').is(':visible') ) {

		// Just in case a submenu is still visible
		$('.js-submenu ul').hide();

		var submenu = el.data('submenu');

		// Show the menu options
		$('.js-submenu-' + submenu).show();
		$('.js-submenu').css('marginLeft', '100%').show().stop().animate({ marginLeft: "0%"} , 800);

	}

};



/**
 * Hide the submenu in mobile
 * @return void
 */
pyzel.submenus.hideMobile = function() {

	// Only runs on mobile
	if ( $('.js-menu-mobile-toggle').is(':visible') ) {
		$('.js-submenu').stop().animate({ marginLeft: "100%"} , 500);
	}

};
// Extend namespace by creating a new object
pyzel.surfboards = pyzel.surfboards || {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.surfboards.init = function() {

	// Init slider status
	if ( typeof pyzel.surfboards.sliderInitiated == undefined ) {
		pyzel.surfboards.sliderInitiated = false;
	}

	// Check for clicks on View all
	// Use this function as an example only, data should be obtained by an ajax call to the server
	$('.js-surfboards-view-all').on('click', function(){
		pyzel.surfboards.addAll( $(this) );
	});

};

/**
 * Adds more surfboards to the container, just for demo usage in the static HTML version
 * @todo refactor this in the dynamic / production version, should get data from an Ajax request with the surfboard category
 *
 * @param {object} el Element
 *
 * @return {void}
 */
pyzel.surfboards.addAll = function(el) {

	var category = el.data('category');

	// Hide the button
	el.css('opacity', 0);

	// This should be an Ajax call
	var firstSurfboard = '<div class="col-sm-4"><a href="index.php?page=surfboards-ratskull" class="slide surfboard-listing-single"><div class="name">The Amigo</div><div class="price">860.00 EUR</div><img src="/images/surfboards-theamigo.jpg" width="340" height="425" alt="Surfboard"><div class="category">High performance</div><div class="specs">0-4ft / Intermed to Advance</div><div class="btn btn-primary btn-sm">See more</div></a></div>';
	var secondSurfboard = '<div class="col-sm-4"><a href="index.php?page=surfboards-ratskull" class="slide surfboard-listing-single"><div class="name">The Amp</div><div class="price">860.00 EUR</div><img src="/images/surfboards-theamp.jpg" width="340" height="425" alt="Surfboard"><div class="category">High performance</div><div class="specs">0-4ft / Intermed to Advance</div><div class="btn btn-primary btn-sm">See more</div></a></div>';
	var thirdSurfboard = '<div class="col-sm-4"><a href="index.php?page=surfboards-ratskull" class="slide surfboard-listing-single"><div class="name">The Slab</div><div class="price">860.00 EUR</div><img src="/images/surfboards-theslab.jpg" width="340" height="425" alt="Surfboard"><div class="category">High performance</div><div class="specs">0-4ft / Intermed to Advance</div><div class="btn btn-primary btn-sm">See more</div></a></div>';

	if ( !$('.js-boards-list-slider').hasClass('slick-initialized') ) {

		$('.js-boards-' + category).append(firstSurfboard + secondSurfboard + thirdSurfboard);

	} else {

		// Slider is enabled, add as new slides
		$('.js-boards-' + category).slick('slickAdd', firstSurfboard);
		$('.js-boards-' + category).slick('slickAdd', secondSurfboard);
		$('.js-boards-' + category).slick('slickAdd', thirdSurfboard);

	}


};
pyzel.vimeo = {

	// TO-DO: cache the token - now is hardcoded
	token : '',

	get_token: function(){

		return $.when(

			$.ajax({

				url: 'https://api.vimeo.com/oauth/authorize/client',
				method: 'post',
				data: {

					grant_type: "client_credentials"

				},
	  			beforeSend: function (xhr) {
	    			xhr.setRequestHeader ("Authorization", "Basic " + btoa('84fe85942b9796e7be2d33a355b6144fbf728d3a'+ ":" + '7CyQ7UktgdyememDwWkv3Jfa/vbNftNEsOP0WVhOG5RG4k/+Z+8xZ3AgU4fV6qPBuLriVsEL9YoblZYgBU8MJrUvVUcxxseVZ+nQtyc2D/8XBE61l09nyDNcTPVkYYyA' ));
				}			

			}).done( function( r ){

				console.log( r.access_token );

				pyzel.vimeo.token = r.access_token;				

			})

		)	
			
	},

	get_image: function( video_id ){				

		//pyzel.vimeo.get_token().then( function(){	

		return $.when(	

			$.ajax({

					url: 'https://api.vimeo.com/videos/'+video_id+'/pictures',
					method: 'get',
					beforeSend: function(xhr){
	            		xhr.setRequestHeader('Authorization', 'bearer 1670850b196f3a3d4ab6bb170190b879'); // does the token expire? if not, hardcode it..!
	            	}

				}).done( r => {

					//console.log('we got images from vimeo:');
					//console.log( r.data[0].sizes[5].link );
					//video_details['image'] = r.data[0].sizes[5].link;

					//return video_details;

					//dfd.resolve();

					//return video_details;

					//return r.data[0].sizes[5].link;

			})

		)		

		//})		
		
	}

}

/*
pyzel.vimeo.get_token().then( function(){

	let img = pyzel.vimeo.get_image();
	//console.log( img );

});
*/

// Functions that run on dom ready
$(function() {

	// Convert images to inline svg
	pyzel.convertToSVG();

	// Init listeners for mobile menu
	pyzel.menuMobile.init();

	// Init submenu listeners
	pyzel.submenus.init();

	// Init sliders (sitewide)
	pyzel.sliders.init();

	// Demo content for static version
	// @todo refactor this in the dynamic / production version
	pyzel.surfboards.init();

	//pyzel.instagram.init();	

});

// Homepage
pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.big_rectangles = {

	init: function(){

		let html = '';
		//let loops = 0;
		let col_class = 'col-sm-6';

		$.ajax({

			url: endpoint+'/cms/zones/64/objects',
			method: 'get'

		}).done( r => {

			//$.each( r, function(){				
			$.each( r, ( k, i ) =>{

				//loops++;

				if( k == 2 ) col_class = 'col-sm-12';

				html = 

				`<div class="${ col_class }">
					<a href="${ i.hpurl || '#' }" class="image-highlight">
						<div class="image">
							<img src="${ i.bannerimg }" alt="${ i.hptitle }">
						</div>
						<div class="description large">
							${ i.hptitle }
						</div>
					</a>
				</div>`;	

				$('#big-rectangles').append( html );

			})

		})

	}
	

}
pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.boards_slider = {

	//default: $(

	init: function(){

			//console.log('board sliders is always happening..?');

			let html = '';

				$.ajax({

					url: endpoint+'/surfboardmodels',
					method: 'get'

				}).done( r => {

					$.each( r, ( k, i ) =>{					      					

						html += 

						`<a href="?page=surfboard-details&id=${ i.id_surfboardmodel }" class="slide surfboard-listing-single">

							<div class="name">

								${ i.surfboardmodel }

							</div>
							
							<div class="price">

								${ i.min_price } EUR

							</div>
							
							<!-- make images adaptive -->
							<img src="${ i.img_dynamic }??w=340&h=553&fit=crop" srcset="${ i.img_dynamic }?w=340&h=553&fit=crop 1200w" alt="${ i.surfboardmodel }" width="340" height="425">

							<div class="category">

								${ i.surfboardmodeltype }

							</div>
							
							<div class="specs">

								${ i.wavesize.min }-${ i.wavesize.max}${ i.wavesize.measure } /

								${ 

									pyzel.helpers.skill_level( i.skilllevel )

								}

							</div>

							<div class="btn btn-primary btn-sm">See more</div>

						</a>`;

					})

					$('#js-homepage-boards-slider').html( html );

					pyzel.sliders.homepageBoards();	

				})


		}

	//)

}
pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.header_slider = {

	init: function(){

			console.log('header sliders was inited?');

			let html = '';

			let videos_total = 0;

			//let videos_array = [];

			$.ajax({

				url: endpoint+'/cms/zones/61/objects',
				method: 'get'

			}).done( r => {

				console.log( r );
				
				$.each( r, ( k, i ) =>{

					// testing
					//i.article_type = 'Image';
					//i.bannerimg = 'https://placeholdit.imgix.net/~text?txtsize=125&txt=1920%C3%97500&w=1920&h=500';

					if( i.article_type == 'Image' ){

						html += 

						`<div class="slide">			
							
							<div class="image" style="background-image: url('${ i.bannerimg }')"></div>

							<div class="description">

								<div class="text">${ i.hptitle }</div>

								<a href="${ i.hpurl || '#' }" class="btn btn-primary">

									${ i.hpmenutitle }

								</a>

							</div>

						</div>`;

					}else if( i.article_type == 'Video' ){

						videos_total ++;

						let url_parts = i.hpurlvideo.split('/');
						
						if( url_parts[2] != 'vimeo.com' ){

							console.log( i.url+' - sorry, vimeo videos only!');
							return 0;

						}

						let video_id = url_parts[ url_parts.length - 1 ];					

						//console.log( i.hpurlvideo );
						//console.log( video_id );

						html += 

						`<div class="slide" style="background:#000">

							<div class="video-loader" style="color:#ccc; text-align:center; width: 100%; margin-top: 20%;">							

								loading Pyzel video...

							</div>			

							<iframe id="vimeo-${video_id}" class="vimeo-iframe" data-id-video="${video_id}" src="https://player.vimeo.com/video/${video_id}?byline=0&amp;portrait=0&amp;loop=0" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>

						</div>`;

					}	
					
				})
				
				$('#header-slider').html( html );

				//--------------------------------------------------------------

				if( videos_total > 0 ){				

					// script was failing to load, so do a plan B
					$.getScript( "https://player.vimeo.com/api/player.js" ).done(function( script, textStatus ) {
					    
						//console.log( 'script loaded' );

						$.each( $('.vimeo-iframe'), ( k, i ) =>{
				    	
				    	//console.log( $( i ).data('id-video') );
				    				    	
					    //var iframe = $('.vimeo-iframe')
					    var player = new Vimeo.Player( $('#vimeo-'+ $( i ).data('id-video') ) );

					    player.on('loaded', function() {

					        console.log('the video was loaded!');

					        $('.video-loader').remove();

					    });				    
					    
					    player.on('play', function() {

					        console.log('played the video!');

					        $('#header-slider').slick('slickPause');

					        // if playing, listen to slick changes to stop the video						
							$('#header-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
							  						 
							  player.pause();

							});

					    });			    	

					    //player.on('pause', function() {
					    // born buggy..? can´t have the api=1 on the embed url				    
					    player.on('ended', function() {	

					        console.log('the video stopped!'); // not firing??

					        //$('#header-slider').slick('slickStart');
					        //$('#header-slider').slick('reinit');
					        $('#header-slider').slick('slickPlay');

					        // got to first frame of video - default state
					        setTimeout(

					        	function(){

									player.unload();
									console.log('player was unloaded');

					        	}, 500

					        )				        

					    });												   
						
				    }) // end each						
					  
					  }).fail(function( jqxhr, settings, exception ) {

					    console.log( 'script NOT loaded' );

					});													

				}else{

					console.log( 'no videos ara available' );					

				} 

				//--------------------------------------------------------------
			    
				pyzel.sliders.homepageTop();


			})

		}

	//)

} 
pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.promo_claims = {
	
	init: function(){

		let html = '';

		$.ajax({

			url: endpoint+'/cms/zones/62/objects',
			method: 'get'

		}).done( r => {

			$.each( r, (k, i) => {

				if( this.hpurl ){

					html += 

					`<div class="col-sm-4 claim">
						<a href="${ this.hpurl || '#' }">
							${ i.hptitle }
						</a>
					</div>`;

				}else{

					html += 

					`<div class="col-sm-4 claim">
						${ i.hptitle }
					</div>`;

				}		

			})

			$('#promo-claims').html( html );

		})

	}
	
}
// small rectangles
pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.small_rectangles = {

	init: //$(

		function(){		

			let html = '';

			$.ajax({

				url: endpoint+'/cms/zones/63/objects',
				method: 'get'

			}).done( r => {

				$.each( r, ( k, i ) => {

					console.log( k );

					// news rectangle should have as background the image of the last news
					// as per the designer instructions
					if( k == 2 ){

						// hardcode test - image sizes don´t match.
						//i.bannerimg = 'https://s3.amazonaws.com/images.shaperbuddy.com/18/cms/1595384168586c.jpg';

						// get all news, as there is no way to do pagination..
						$.ajax({

							url: endpoint+'/cms/zones/65/objects',
							method: 'get'

						}).done( x => {

							i.bannerimg = x[0].hpthumb;

							html = 

							`<div class="col-md-12 col-lg-4">

								<a href="${ i.hpurl || '#' }" class="image-highlight">

									<div class="image">

										<img src="${ i.bannerimg }" alt="${ i.hptitle }">

									</div>

									<div class="description">

										${ i.hptitle }

									</div>
									
								</a>

							</div>`;

							$('#small-rectangles').append( html );

						})

					}else{

						html = 

						`<div class="col-md-12 col-lg-4">

							<a href="${ i.hpurl || '#' }" class="image-highlight">

								<div class="image">

									<img src="${ i.bannerimg }" alt="${ i.hptitle }">

								</div>

								<div class="description">

									${ i.hptitle }

								</div>
								
							</a>

						</div>`;

						$('#small-rectangles').append( html );

					}					

				})			

			})			

		}

	//)

}	

// Surfboards
pyzel.surfboard_details = {

	init: function( id ){

		//alert( id );
		//console.log('get details for board: '+id);

		// get models
		$.get({

			url: endpoint+'/surfboardmodels/'+id+'/build',
			//method: 'get'

		}).done( r => {		

			r = r[0];

			//console.log( r );

			$('.model-name').text( r.surfboardmodel );
			$('#model-logo').prop('src', r.img_logo );
			$('#model-price').text( r.min_price );

			// get first p element, or get from API?
			// here the text does not bring paragraphs from the start..
			
			//let intro_text = $( r.description ).filter('p:first').text();

			//let intro_text = $( r.description ).filter('p:first').text();
			//let intro_text = $("<textarea/>").html(r.description).html();//$( r.description ).filter('p:first').text();
			//let body_text = r.description.replace( intro_text, '' );

			// improv. intro and body as they are not served from API
			// nor have standard formating, ie: paragraphs
			let bio_intro = r.description.split('.');

			$('#model-description-intro').html( bio_intro[0]+'.' );
			$('#model-description-body').html( r.description.replace( bio_intro[0]+'.' , '' ) );

			//$('#model-description-intro').text( intro_text );
			//$('#model-description-body').html( body_text );							
			

			//$('#model-description-intro').html( r.description );
			$('#model-category').text( r.surfboardmodeltype );
			$('#breadcrumb-surfboard-category').prop('href', '?page=surfboards#'+pyzel.helpers.safe_name( r.surfboardmodeltype ) ).text( r.surfboardmodeltype );			

			$('#model-wave-size').text( r.wavesize.min+'-'+r.wavesize.max + r.wavesize.measure );
			$('#model-skill-level').text( pyzel.helpers.skill_level( r.skilllevel ) );

			let board_features = pyzel.helpers.board_features( r.features );

			//console.log( board_features );

			$('#model-tails').text( board_features['tail'] );
			$('#model-rails').text( board_features['rails'] );
			
			$('#model-fins').text( pyzel.helpers.csv( r.finsystem ) );
			$('#model-fins-setup').text( pyzel.helpers.csv( r.fin_setup ) );
			
			//$('#model-technology').text( pyzel.helpers.csv( r.technology ) );
			$('#model-technology').text( pyzel.helpers.csv( r.construction_type, 'constructiontype' ) );
			
			$('#model-sprays').text( pyzel.helpers.csv( r.paint ) );

			$('#wave-height-graphic-min-size').text( r.wavesize.min );
			$('#wave-height-graphic-max-size').text( r.wavesize.max );
			$('.wave-height-graphic-measure').text( r.wavesize.measure );

            $.each( r.skilllevel, ( k, i ) => {

            	//console.log( k );
            	//console.log( i );

            	//console.log( $('.skill-level-'+k) );

                $('.skill-level-'+k).addClass('skill-level-selected');

            }) 			

			//console.log( pyzel.helpers.csv( r.technology ) );

			pyzel.social.init();

			//------------------------------------------------------------------
			// custom order and shop links - TOP OF THE PAGE
			// THE BIG BUTTONS ARE DEFAULT - no specs, just the model..					

			$('#custom-order-link').prop( 'href','/custom-order?model='+id );			
			// so much for pretty urls..
			$('#shop-link').prop('href','?page=shopsurfboard&model='+id );			

			//------------------------------------------------------------------
			// board slider

			let slider_html = '';

			//console.log( r.img );

			$.each( r.img, ( k ,i ) => {

				//console.log( k );

				if( i.cover == 1 )
					$('#pinterest-img').data('img', i.img_dynamic ).data('txt', r.surfboardmodel +' - '+r.surfboardmodeltype  );

				slider_html +=

				`<div class="slide">

					<img src="${ i.img_dynamic }" width="1050" height="1050" alt="Pyzel surfboard details">

				</div>`;			

			})// end each		

			let table_html = '';
			let action_btn = '';

			$.each( r.standard_dimensions, ( k , i ) => {

				//console.log( k );
				//console.log( i );

				let model_specs = 'model='+id+'&length='+i.length+'&width='+i.width+'&thickness='+i.thickness;

				if( i.currentavailability == 1 ){

					action_btn = `
						<a href="?page=shopsurfboard&${ model_specs }" class="btn btn-black btn-full">Buy now</a>
						<a href="?page=shopsurfboard&${ model_specs }" class="round-btn cart"></a>`;

				}else{

					action_btn = `
						<a href="/custom-order?${ model_specs }" class="btn btn-primary btn-full">Custom order</a>
						<a href="/custom-order?${ model_specs }" class="round-btn custom"></a>`;

				}

				table_html += 

				`<tr>
					
					<td>
						${ i.length_inches }
					</td>

					<td>
						${ i.width_inches }
					</td>

					<td>
						${ i.thickness_inches }
					</td>

					<td>
						${ i.volume }L
					</td>

					<td class="actions">
						${ action_btn }
					</td>

				<tr>`;			

			})

			$('#model-standard-dimensions tbody').append( table_html );

			//pyzel.helpers.get_video_details( r.videos );

			//------------------------------------------------------------------
			// videos - maybe a function?

			let videos_html = '';

			//console.log('videos length:');
			//console.log( r.videos.length );

			let vimeo_videos_total = 0;

			let loops = 0;

			$.each( r.videos, ( k ,i ) => {

				//console.log( i );
				//console.log( k );

				//let video_details = pyzel.helpers.get_video_details( i );

				//pyzel.helpers.get_video_details( i ).then( function( r ){});

				/*
				pyzel.helpers.get_video_details_test( i ).then( function( r ){

					console.log( 'response of deferred:' );
					console.log( r );

				});
				*/
							
				//pyzel.helpers.get_video_details( i ).then( function( r ){
				//$.when( pyzel.helpers.get_video_details( i ) ).then( function( r ){
				//pyzel.helpers.get_video_details( i ).then( function( r ){

				// parse id - make a function?
				// it should also detect if is vimeo or youtubiu
				// the site was done only to handle vimeo

				let url_parts = i.url.split('/');				

				if( url_parts[2] != 'vimeo.com' ){

					console.log( i.url+' - sorry, vimeo videos only!');
					return 0;

				}else{

					vimeo_videos_total ++;	

				}

				let video_id = url_parts[ url_parts.length - 1 ];
				//console.log( id );

				if( isNaN( video_id ) ){

					console.log( 'invalid video id: '+video_id );
					return 0;

				}

				pyzel.vimeo.get_image( video_id ).then( function( img ){

					loops ++;

					let video_img = img.data[0].sizes[ img.data[0].sizes.length -1 ].link;				

					videos_html = `

					<div class="slide">
						<a href="#" data-vimeo-id="${ video_id }" class="js-fullwidth-video-play">
							<div class="image" style="background-image: url('${ video_img }')"></div>
							<div class="play">
								<img src="/images/play-circle.svg" width="230" height="230" class="play-circle" alt="Play">
							</div>
						</a>
					</div>`;

					$('#model-videos-placeholder').append( videos_html );

					console.log( k );

					//if( r.videos.length - 1 == k ){
					if( vimeo_videos_total == loops ){

						console.log('videos length equal current video.');
						pyzel.convertToSVG();
						pyzel.fullwidthVideo.init();
						pyzel.sliders.fullwidthVideo();
						//pyzel.fullwidthVideo.init();

					}

				});

				//$('#model-videos-placeholder').append( videos_html );
				
				//pyzel.sliders.fullwidthVideo();			
				//pyzel.fullwidthVideo.init();

			})													

			//------------------------------------------------------------------
			// other models - should load with lazy load..

			let other_models_html = '';

			$.each( r.other_models, ( k, i ) => {

				//console.log( i );

				other_models_html += `
					
					<a href="index.php?page=surfboard-details&id=${ i.id_surfboardmodel }" class="slide surfboard-listing-single">

						<div class="name">
							${ i.surfboardmodel }
						</div>
						
						<div class="price">

							${ i.min_price } EUR

						</div>

						<img src="${ i.img_dynamic }?w=700" width="340" height="425" alt="${ i.surfboardmodel }">

						<div class="category">
							
							${ i.surfboardmodeltype }

						</div>

						<div class="specs">

							${ i.wavesize.min }-${ i.wavesize.max }${ i.wavesize.measure } 

						</div>

						<div class="btn btn-primary btn-sm">See more</div>

					</a>`;

			})

			let el = $('#other-boards-placeholder');

			el.html( other_models_html );

			el.slick({
				slidesToShow: 4,
				slidesToScroll: 4,
				arrows: false,
				dots: true,
				dotsClass: 'slider-pager',
				autoplay: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});

			$('#model-slider').html( slider_html );

			//------------------------------------------------------------------

			//pyzel.convertToSVG();
			pyzel.sliders.surfboardDetails();
			//pyzel.sliders.fullwidthVideo();			
			//pyzel.fullwidthVideo.init();

		})// end ajax done

	}

}
// recovered due to lost connection on the VPN..

pyzel.surfboard_models = {
	
	default : function(){			

		//alert();

		console.log( 'surfboard models loaded' );
		console.log( window.location.hash );

		// disable default behaviour on the submenu
		// and do some anim on the scroll

		$('.js-submenu-surfboards .model-link').on('click', e => {

			//console.log('scrolling on menu click');

			e.preventDefault();

			//console.log( $(e.target).prop('href').split('#')[1] );

			let category = $(e.target).prop('href').split('#')[1];
			let el = $('#'+category );

			//console.log( "el:" );
			//console.log( el.offset().top );

			//$("body").stop().animate({
			$("html").stop().animate({
  			
  				scrollTop: el.offset().top - 100 }, 2000, function(){ 

  					window.location.hash = category;
  					console.log("animation stopped");

  				});

			})

			let html = '';

			// get models

			$.ajax({

				//url: endpoint+'/surboardmodeltypes',
				//url: 'http://antonio.shaperbuddy.com/api/v1/surfboardmodeltypesdescription?lang=en',
				url: endpoint+'/surfboardmodeltypesdescription?lang=en',
				method: 'get'

			}).done( r => {

				//console.log( r );
				//return false;

				let total_models = Object.keys(r).length;
				let loop_models = 0;
				//console.log( total_models );

				//$.each( r, ( k, i ) =>{
				$.each( r, ( k, i ) =>{

					loop_models++;
					
					//console.log( "i.name" );
					//console.log( i.name );
					//console.log( "i.id" );
					//console.log( i.id );

					//return false;

					//console.log( loop_models );
					
					html = `
					
					<div class="container-fluid surfboard-listing" id="surfboard-listing-${ i.id }">
						<div class="col-sm-12 col-md-3 details" id="${ pyzel.helpers.safe_name( i.name ) }">
						<div class="title">${ i.name }</div>
						<p class="description">

							${ i.description }

						</p>
						<div class="btn btn-primary js-surfboards-view-all hide" data-id-category="${ i.id }" id="btn-view-all-${ i.id }">
							View all
						</div>
					</div>
					<!-- Boards -->
						<div class="col-sm-12 col-md-9 js-boards-list-slider" id="models-of-category-${ i.id }"></div>
					</div>`;

					$('#models-placeholder').append( html );
					// now get board of this model
					//console.log('ended '+i.surfboardmodel);				

					var display_mode;

					if( window.location.hash == '#all' )
						var display_mode = 'all';

					pyzel.surfboard_models.models_per_category( i.id, 0, display_mode ).then( ()=> {

						if( total_models == loop_models ){
					
							//console.log('ended models loop?');

							if( window.location.hash != '' &&  window.location.hash != '#all' ){

								//console.log('scrolling on location hash');
		
								let category = window.location.hash.replace('#', '');
								//console.log( category );
								//console.log( $('#'+category) );
								let el = $('#'+category);
								//console.log('distance of element is:');
								//console.log( el.offset().top );							
								$("body").stop().animate({ scrollTop: el.offset().top - 100 }, 2000, function() { 
								
									//console.log('finished animation');

								});

							}
						}

					});

					// this can only happen after this ^
					// or the model description must have a defined height
					/*
					if( total_models == loop_models ){
					
						console.log('ended models loop?');

						if( window.location.hash != '' ){

							console.log('scrolling on location hash');
	
							let category = window.location.hash.replace('#', '');
							console.log( category );
							console.log( $('#'+category) );
							let el = $('#'+category);
							console.log('distance of element is:');
							console.log( el.offset().top );							
							$("body").stop().animate({ scrollTop: el.offset().top - 100 }, 2000, function() { 
							
								console.log('finished animation');

							});

						}
					}
					*/
			}) // end each model			

			$( '#model-link-'+window.location.hash.replace('#', '') ).trigger('click');

		})

		
		$(document).on('click', '.js-surfboards-view-all', function( e ){
			
			//console.log( e.originalEvent );
			//console.log( e.currentTarget );		
			
			let el = $( e.target );
			el.html('loading..');			
			e.preventDefault();		
			//pyzel.surfboard_models.models_per_category( el.data('id-category'), 3, e.originalEvent );			
			pyzel.surfboard_models.models_per_category( el.data('id-category'), 3 );			

		})
		

	}, // end default

	/**
	* gets the model of category
	*
	* @return {void}
	*/

	models_per_category: function( id_category, start = 0, display_mode ){

		/*
		console.log( "id_category" );
		console.log( id_category );
		console.log( "start" );
		console.log( start );
		*/

		//console.log( 'display_mode' );
		//console.log( display_mode );

		// store the models
		//let models_of_category = [];
		// it should cache

			return $.when(

			$.ajax({
				url: endpoint+
				'/surfboardmodels?id_surfboardmodeltype='+id_category,
				method: 'get'
			}).done( r => {
				
				
				let html = '';

				if( r.length < 3 )			
					$('#btn-view-all-'+id_category).hide();
					//console.log( r );
					
				// API does not limit the results, so
				// cut the array - chop chop

				if( start == 0 && display_mode == undefined ){

					r = r.slice( 0, 3 );
					$('.js-surfboards-view-all').removeClass('hide');

				}else if( display_mode == 'all' ){
					r = r; // redundant..
					//$('.js-surfboards-view-all').hide();
				}					
				else {
					r = r.slice( 3 );
					$('.js-surfboards-view-all').removeClass('hide');
				}					
					
				$.each( r, ( k, i ) => {
					
					html += 

					`<div class="col-sm-4">
						
						<a href="index.php?page=surfboard-details&id=${ i.id_surfboardmodel }" class="slide surfboard-listing-single">

							<div class="name">
								${ i.surfboardmodel }
							</div>
							
							<div class="price">
								${ i.min_price } EUR
							</div>

							<!-- make images adaptive -->
							<img src="${ i.img_dynamic }?w=340&h=520&fit=crop" srcset="${ i.img_dynamic }?w=340&h=520&fit=crop 1200w" alt="${ i.surfboardmodel }" width="340" height="425">

							<div class="category">
								${ i.surfboardmodeltype }
							</div>

							<div class="specs"> 

								${ i.wavesize.min }-${ i.wavesize.max }${ i.wavesize.measure } / ${ pyzel.helpers.skill_level( i.skilllevel ) }
							
							</div>
							
							<div class="btn btn-primary btn-sm">

								See more

							</div>

						</a>

					</div>`;
					
			
			}) // end each

				$('#models-of-category-'+id_category).append( html );

				//console.log('here i got.');

				//console.log( 'trigger' );
				//console.log( trigger );

				// scroll to new loaded boards
				//if( start != 0 && trigger !== 'undefined' ){
				if( start != 0 ){

				// 800 ~ height of board

					//console.log('start != 0');

					$("body").stop().animate({ scrollTop: $(window).scrollTop() + 800  }, 2000, function() { 

						$('#btn-view-all-'+id_category).fadeOut(1000);

						//console.log('animation stopped?');

					});

				}else{

					//console.log('start is: '+start);

				}

			}) // end done get board per model?			

			)// end when								
			
		//console.log('this does not happen, because of the return statment.');	
	
	//}); // end done get board per model?
	
	} // end get model per category

}// end namespace

// Team
pyzel.team = {

	riders: function(){

		$.ajax({

			url: endpoint+'/team',
			method: 'get'

		}).done( r => {

			let col_class = '';
			let placeholder = '';
			let html = '';

			$.each( r, ( k, i ) => {								

				// top rider
				if( i.order == '1.00' ){

					col_class = 'col-sm-12';
					placeholder = 'top-rider-placeholder';

				}else{

					col_class = 'col-sm-6';
					placeholder = 'other-riders-placeholder';

				}

				html = 

				`<div class="${ col_class }">

					<a href="?page=team-rider&id=${ i.id_team }&${ pyzel.helpers.safe_name( i.name ) }" class="image-highlight">

						<div class="image">
					
							<img src="${ i.photothumb }" alt="Team">
							
						</div>

						<div class="description large">
							
							${ i.name }
							
							<div class="tagline">
								
								${ i.homebase }

							</div>

						</div>

					</a>

				</div>`;

				$( '#'+placeholder).append( html );

			})

		})

	},

	details: function( id ){		

		$.ajax({

			url: endpoint+'/team/'+id,
			method: 'get'

		}).done( r => {				

			// 404
			if( ! r.name ){				
				window.location = './?404';
				return 0;
			}			

			$('.rider-name').text( r.name );

			// improv. intro and body as they are not served from API
			// nor have standard formating, ie: paragraphs
			
			//let bio_intro = r.bio.split('.');
			//$('#description-intro').html( bio_intro[0]+'.' );
			//$('#description-body').html( r.bio.replace( bio_intro[0]+'.' , '' ) );

			//$('#bio-placeholder').html( r.bio );
			$('#bio-placeholder').html( r.description );

			//--------------------------------------------------------
			// slider - from multimedia?

			let slider_html = '';

			$.each( r.multimedia, ( k, i ) => {

				console.log( i.cmsmultimediatype );

				if( i.cmsmultimediatype != 'image' ) return 0;
				if( i.autoinclude != 1 ) return 0;

				slider_html += `

					<div class="slide">

						<div class="image">
							
							<img src="${ i.url }" alt="Slide">

						</div>
						
						<div class="description large">

							${ r.name }
						
							<div class="tagline">

								${ r.homebase }

							</div>

						</div>

					</div>`;							

			})

			$(document).trigger('team-rider-slides-loaded');

			$('#team-rider-slider').html( slider_html );
			pyzel.sliders.about(); // make dedicated slider, and call the quiver after being inited			

			//--------------------------------------------------------
			// quiver

			// now image comes from other place, the one from multimedia that is not autoinclude

			$.grep( r.multimedia, ( x )=>{

				if( x.autoinclude == 0 ){

					$('#quiver-rider-picture').css({'background-image': 'url('+x.url+')'})

				}

			})	

			// quiver boards

			let quiver_html = '';

			$.each( r.surfboardmodels, ( k, i ) => {

				let logo = $.grep( i.images, x => {

					return x.id_phototype == 419;

				})[0].photomax;

				let cover_image = $.grep( i.images, x => {

					return x.cover == 1;

				})[0].photomax;
				//})[0].image_400;

				quiver_html += `

					<li>

						<div class="col-md-2 col-sm-4 hidden-xs surfboard">
							<img src="${ cover_image }" width="250" height="825" alt="${ i.surfboardmodel }">
						</div>
						<div class="col-md-9 col-sm-8 col-xs-12">

							<div class="icon">
								<img src="${ logo }" height="81" alt="${ i.surfboardmodel }">
							</div>

							<h3>${ i.surfboardmodel }</h3>
							<div class="price">${ i.minprice } EUR</div>

							<div class="mobile">

								<img src="${ cover_image }" width="250" height="825" alt="${ i.surfboardmodel }">

							</div>

							<div class="spec-list clearfix">
								<div class="spec">
									<div class="title">Size</div>
									${ i.height }
								</div>

								<div class="spec">
									<div class="title">Width</div>
									${ i.wide }
								</div>

								<div class="spec">
									<div class="title">Thickness</div>
									${ i.thick }
								</div>

								<div class="spec">
									<div class="title">Volume</div>
									${ i.volume }L
								</div>
							</div>

							<div>

								<a href="?page=shopsurfboard&model=${ i.id_surfboardmodel }" class="btn btn-black btn-md">Buy now</a>

							</div>

						</div>

					</li>`;

			})

			$('#quiver-placeholder').html( quiver_html );
						
			let videos_html = '';

			// filter videos

			let vimeo_videos_total = 0;

			r.multimedia = $.grep( r.multimedia, ( x )=>{			
								
				return x.cmsmultimediatype == 'video';

			})

			//console.log( "r.multimedia.length" );
			//console.log( r.multimedia.length );

			let loops = 0;

			$.each( r.multimedia, ( k, i ) =>{			

				//if( i.cmsmultimediatype != 'video' ) return 0;

				//pyzel.helpers.get_video_details( 70482348 );			

				//console.log( k );
				//console.log( i );			
				
				// should be a function..
				let url_parts = i.url.split('/');				

				if( url_parts[2] != 'vimeo.com' ){

					console.log( i.url+' - sorry, vimeo videos only!');
					return 0;

				}else{

					vimeo_videos_total ++;	

				}				

				let video_id = url_parts[ url_parts.length - 1 ];
				//console.log( id );

				pyzel.vimeo.get_image( video_id ).then( function( img ){	

					loops ++;

					//console.log('vimeo returned:');
					//console.log( img );
					//console.log( img.data[0].sizes.length );
					//console.log( img.data[0].sizes[5].link );

					let video_img = img.data[0].sizes[ img.data[0].sizes.length -1 ].link;

					//return 0;				

					videos_html = `

					<div class="slide">
						<a href="#" data-vimeo-id="${ video_id }" class="js-fullwidth-video-play">
							<div class="image" style="background-image: url('${ video_img }')"></div>
							<div class="play">
								<img src="/images/play-circle.svg" width="230" height="230" class="play-circle" alt="Play">
							</div>
						</a>
					</div>`;

					$('#videos-placeholder').append( videos_html );
					
					//console.log( 'r.multimedia.length - 1' );
					//console.log( typeof ( r.multimedia.length - 1 ) );
					/*
					console.log( 'loops' );
					console.log( loops );
					console.log( 'vimeo_videos_total' );
					console.log( vimeo_videos_total );
					*/

					// this is not stable.
					if( vimeo_videos_total == loops ){

						//console.log('videos length equal current video.');
						
						pyzel.convertToSVG();
						pyzel.fullwidthVideo.init();
						pyzel.sliders.fullwidthVideo();				
						//pyzel.fullwidthVideo.init();						

					}				

				});


			})			

			//--------------------------------------------------------
			// social networks - instagram ( and others? )

		 	pyzel.social.init();

		 	pyzel.social.build_links( r.socialnetworks );

			let instagram_ids = [];

			instagram_ids[66] = 3496115;
			instagram_ids[67] = 14549197;
			instagram_ids[61] = 2908025;
			instagram_ids[63] = 12937887;
			instagram_ids[65] = 14698567;
			instagram_ids[121] = 4900407;
			instagram_ids[95] = 143930877;
			instagram_ids[120] = 13105855;
			instagram_ids[122] = 25438874;
			instagram_ids[123] = 2877810420;
			instagram_ids[64] = 477842536;
			// @thatcher.johnson: User ID: 477842536 - private
			instagram_ids[124] = 1937775322;
			instagram_ids[125] = 252595423;

			// 2877810420
			// 13105855
			//NathaN_Florence @nathan_florence: User ID: 143930877

			//4900407

			pyzel.instagram.init( instagram_ids[ id ] );

		})

		$( document ).on('team-rider-slides-loaded', ()=>{

			console.log('team-rider-slides-loaded');

			pyzel.quiver.init();
			pyzel.sliders.teamQuiver()

		});

	}
	
}	

// News
pyzel.news = {

	list: function(){

		//alert();

		// highlight or not
		let news_class = 'highlight';
		let social_class = 'invert';
		let html = '';

		$.ajax({

			url: endpoint+'/cms/zones/65/objects',
			method: 'get'

		}).done( r => {

			//console.log( r );

			$.each( r, ( k, i ) => {

				console.log( k );

				if( k > 0 ){

					news_class = '';
					social_class = '';

				}

				// define the URL to be shared
				let host = window.location.protocol+'//'+window.location.host; 
				let share_url = encodeURIComponent( host+'?page=?page=news-detail&id='+i.id_cmsconteudo );

				//console.log( share_url );				

				// define WHERE to be shared
				let facebook_share_url = 'https://www.facebook.com/sharer/sharer.php?u='+share_url;
				let google_share_url = 'https://plus.google.com/share?url='+share_url;
				let twitter_share_url = 'https://twitter.com/intent/tweet?text='+encodeURIComponent( i.hptitle )+': '+share_url;					

				html +=

				`<div class="${ news_class } clearfix">
					
					<div class="col-sm-6 image">

						<img src="${ i.hpthumb }" alt="${ i.hptitle }" width="960" height="550">

					</div>
					
					<div class="col-sm-6 details">

						<a href="?page=news-detail&id=${ i.id_cmsconteudo }&${ pyzel.helpers.safe_name( i.hptitle ) }" class="title">

							${ i.hptitle }

						</a>
						
						<div class="date">

							${ pyzel.helpers.format_date( i.dt_pub ) }

						</div>

						<p class="excerpt">

							${ i.hpresume }

						</p>

						<a href="?page=news-detail&id=${ i.id_cmsconteudo }&${ pyzel.helpers.safe_name( i.hptitle ) }" class="btn btn-primary">Read all</a>

						<div class="article-share ${ social_class }">

							<div class="title">Share</div>

							<div class="icons">

								<a href="#" class="icon facebook" data-url="${ facebook_share_url }"></a>
								<a href="#" class="icon googleplus" data-url="${ google_share_url }"></a>
								<a href="#" class="icon twitter" data-url="${ twitter_share_url }"></a>

							</div>

						</div>

					</div>					

				</div>`;

			})		

			$('#news-placeholder').html( html );

			pyzel.social.init();		

		})

	},

	details: function( id ){	

		let html = '';

		$.ajax({

			url: endpoint+'/cms/zones/65/objects/'+id,
			method: 'get'

		}).done( r => {

			console.log( r[0] );

			r = r[0];

			$('#cover-img').prop('src', r.hpthumb );
			$('#news-breadcrumb, #news-title').text( r.hptitle );
			$('#news-time').text( pyzel.helpers.format_date( r.dt_pub ) ).prop('datetime', r.dt_pub);

			/*
			// get first p element, or get from API?
			// filter fails if text has html in it, like a href..
			let intro_text = $( r.atext ).filter('p:first').text();
			//let intro_text = $( r.atext ).first('p').html();
			//let intro_text = $( r.atext ).first('p').html();
			//let intro_text = $( r.atext ).first('p').text();

			console.log( 'intro_text' );
			console.log( intro_text );

			let body_text = r.atext.replace( intro_text, '' );

			$('#news-intro').text( intro_text );
			$('#news-body').html( body_text );
			*/

			// using CSS is way simpler..
			$('#news-placeholder').html( r.atext );

			pyzel.social.init();

		})			

	}

}

// Sprays
// art/paint

pyzel.sprays = {

	list: () =>{

		$.ajax({

			url: endpoint+'/art/paint',
			method: 'get'

		}).done( r => {

			let html = `<div class="row">`;
			let loops = 0;

			console.log( r );

			$.each( r, ( k, i ) => {

				loops++;

				// replace http by https on the images url
				i.image = i.image.replace('http','https');

				html += `				

					<div class="col-md-3 col-sm-6 col-xs-12" >

						<a href="${ i.image }" data-toggle="lightbox" data-gallery="sprays" data-title="${ i.name }" data-type="image">

							<img src="${ i.image }" class="img-responsive" alt="${ i.name }" class="img-fluid">

						</a>	

						<span>spray</span>
						<p>${ i.name }</p>

					</div>

				`;

				// close previous row, open new
				if( loops == 4 ){

					html += `
						</div><div class="row">
					`;

				}

			})

			$('#sprays-placeholder').html( html );

			
			$(document).on('click', '[data-toggle="lightbox"]', function(event) {

				//alert();

			    event.preventDefault();

			    $(this).ekkoLightbox({
			    	
			    	loadingMessage: 'loading Pyzel spray'

			    });

			});

		})// end done

		$(window).load( ()=>{

			console.log('new images were loaded??');

		})

	}	

}

// Pages


pyzel.technology = {

	details: ( id )	=>{

		//console.log( id );

		$.ajax({

			// it should get by technology id, and not all..
			url: endpoint+'/cms/zones/67/objects',
			method: 'get'

		}).done( r => {		

			console.log( r );

			// filter the response..
			let current_technology = $.grep( r, ( x )=>{

				return x.id_cmsconteudo == id;

			})[0];			

			$('.technology-name').text( current_technology.hptitle );			

			$('#technology-placeholder').html( current_technology.atext );
			
			//--------------------------------------------------------	
			// slider

			let slider_html = '';

			$.each( current_technology.multimedia, ( k, i )=>{		

				if( i.multimediatype != 'Image' ) return 0;

				slider_html += `

					<div class="slide">

						<div class="image">
							<img src="${ i.filename }" alt="Slide">
						</div>						

					</div>

				`;

			})

			$('#technology-slider').html( slider_html );
			
			pyzel.sliders.technology();

			pyzel.social.init();

		})

	}

}
pyzel.about = {

	default: () =>{

		//alert('browsersync reload. is this working? yes! great!');

		$.ajax({

			url: endpoint+'/team/116',
			method: 'get'

		}).done( r => {

			console.log( r );

			//------------------------------------------------------------------
			// esláiderr

			let slider_html = '';

			$.each( r.multimedia, ( k, i ) => {

				if( i.cmsmultimediatype != 'image' ) return 0;

				slider_html += `

					<div class="slide">

						<div class="image">
							<img src="${ i.url }" alt="Slide">
						</div>
						<div class="description large">
							Jon Pyzel
							<div class="tagline">North shore of Oahu - Hawaii</div>
						</div>

					</div>

				`;

			})

			$('#pyzel-slider').html( slider_html );

			pyzel.sliders.about();

			//------------------------------------------------------------------		

			// TO-DO: this is inserting paragraphs inside paragraphs, which is illegal..!
			let intro_text = $( r.description ).filter('p:first').text();
			let body_text = r.description.replace( intro_text, '' );

			$('#description-intro').text( intro_text );
			$('#description-body').html( body_text );	

			pyzel.social.init();

			pyzel.social.build_links( r.socialnetworks );

			/*
			$.each( r.socialnetworks, ( k, i )=>{

		 		//console.log( i );

		 		// FB
		 		if( i.id_socialnetwork == 1 ){

		 			$('.icons a.icon.facebook').css('display','inline-block').show().data( 'url', i.url );

		 		// twitter
		 		}else if( i.id_socialnetwork == 2 ){

		 			$('.icons a.icon.twitter').css('display','inline-block').data( 'url', i.url );

		 		// insta	
		 		}else if( i.id_socialnetwork == 4 ){

		 			$('.icons a.icon.instagram').css('display','inline-block').data( 'url', i.url );

		 			let instagram_url_array = i.url.split('/');
		 			$('#instagram-name').text( '@'+instagram_url_array[ instagram_url_array.length - 1 ] );

		 		}else{

		 			console.log('icon for this network ('+i.socialnetwork+') does not exist on the GUI');

		 		}


		 	})
		 	*/			

		})

	}

}
// this could all on one page..

pyzel.privacy = {
	
	default: ()=>{

		$.ajax({

			url: endpoint+'/cms/zones/66/objects/649',
			method: 'get'

		}).done( r =>{

			console.log( r );	

			$('#privacy-placeholder').html( r[0].atext );

		})		

	},

}
pyzel.shipping = {
	
	default: ()=>{

		$.ajax({

			url: endpoint+'/cms/zones/66/objects/646',
			method: 'get'

		}).done( r =>{

			//console.log( r );	

			$('#shipping-placeholder').html( r[0].atext );

		})		

	},

}
// this could all on one page..

pyzel.terms = {
	
	default: ()=>{

		$.ajax({

			url: endpoint+'/cms/zones/66/objects/650',
			method: 'get'

		}).done( r =>{

			console.log( r );	

			$('#terms-placeholder').html( r[0].atext );

		})		

	},

}

// Contacts
pyzel.dealers_old = {

	// if the world was perfect..
	// countries must be defined looping on the dealers...
	/*
	get_countries: ()=>{

		return $.when(

			$.ajax({

				url: endpoint+'/countries',
				method: 'get'

			}).done( r => {

				console.log( r );

			})

		);		

	}*/

	default: ()=>{

		//let countries = [];
		let countries = {};
		let countries_loaded = [];
		let states = [];
		let states_loaded = [];
		let states_per_country = {};
		let stores_per_country = {};
		let stores_per_state = {};

		$.ajax({

			url: endpoint+'/dealers',
			method: 'get'

		}).done( r => {

			//console.log( r[0].id_country );

			//countries.push( r.country );
			//countries[ r.id_country ] = r.country;
			
			//let x = [];

			// populate countries array
			$.each( r, ( k, i ) => {

				//states = [];

				//console.log( k );
				//console.log( i.id_country  );

				//----------------------------------------------------
				// store countries

				//if( $.inArray( i.id_country,  countries_loaded ) == -1){				
										
					countries[ i.id_country ] = i.country;
					
					//countries_loaded.push( i.id_country );				

				//}else{

					//console.log('country already loaded');

				//}

				//----------------------------------------------------					
				// store states

				let x = [];

				if( i.id_state != '' ){

					//console.log( i.id_state );

					//states[ i.id_country ].push( ) i.state;					
					//countries[ i.id_country ].states = i.state;	

					//let x = [ i.id_state, i.state ];

					//let x = {};					
					//x[ i.id_state ] = i.state;
					//x[ i.id_state ] = i.state;

					let id_state = i.id_state;
					let state = i.state;

					x.push( { id_state : state } )

					//if( states_per_country[ i.id_country ] )
					//if(  )

					// check if state is loaded
					if( $.inArray( i.id_state,  states_loaded ) == -1 ){

						
						if( states_per_country[ i.id_country ] )
														
							states_per_country[ i.id_country ].push( x ); //= states;

						else{

							//states_per_country[ i.id_country ] = [];							
							states_per_country[ i.id_country ] = [];							
							states_per_country[ i.id_country ].push( x  ); //= states;

						}
						

						//states_per_country[ i.id_country ] = [ x ];
						//states_per_country = [ x ];

						states_loaded.push( i.id_state );

					}

					//console.log( x );
					//states_per_country = x;
					//states_per_country.item = x;				

					// assign store to state
					if( stores_per_state[ i.id_state ] )
						stores_per_state[ i.id_state ].push( i ); 
					else{
						stores_per_state[ i.id_state ] = [];
						stores_per_state[ i.id_state ].push( i ); 
					}

						
				}else{ // store has no state, so add to countries

					//console.log('this store has no state');

					if( stores_per_country[ i.id_country ] ){

						stores_per_country[ i.id_country ].push( i );

					}else{

						stores_per_country[ i.id_country ] = [];
						stores_per_country[ i.id_country ].push( i );

					}


				}

				//----------------------------------------------------								

			})// end iterate stores

			//console.log( states );
			//console.log( states_per_country );
			//console.log( stores_per_country );
			//console.log( stores_per_state );

			//console.log( countries.length );
			//console.log( countries );
			//console.log( countries_loaded.length );

			// filter undefined values..
			//countries = countries.filter( n => true );
			
			//console.log( countries.length );

			//console.log( states_per_country.item );
			//console.log( states_per_country );
			//console.log( states_per_country[28] );	

			let dealers_html = '';

			//--------------------------------------------------------
			// loop countries 
			$.each( countries, ( k, i ) =>{

				//console.log( k );
				//console.log( i );
				//console.log( x );
				//console.log( countries );

				if( i === undefined ) return 0;

				// populate select
				
				$('#country').append($("<option/>", {
	        		value: k,
	        		text: i
	    		}));

				// append countries

				dealers_html += `

					<div class="country container clearfix">

						<div class="row" id="country-${ k }">

							<div class="col-sm-12">
								
								<h2>${ k } : ${ i }</h2>
								
							</div>

						</div>	

					</div>	

				`;

			})// end loop countries

			$('#dealers-placeholder').html( dealers_html );

			$.each( states_per_country, ( k, i ) =>{

				console.log( k );
				//console.log( i );
				console.log( states_per_country );

				$('#country-'+k).append('hello<hr>')

			})			
			

		})

		//------------------------------------------------------------
		// loop states, assign them to the country

		//console.log( Object.keys( states_per_country ) );			

		//console.log( typeof states_per_country );			

		//console.log( states_per_country.28[0] );			

		//console.log( states_per_country );

		/*
		for (var key in states_per_country) {
  			console.log(key);
		}

		for (var key in states_per_country ) {
		  console.log(key, states_per_country[key]);
		}
		*/
	

	}

}

// get countries
// https://pyzeleurope.shaperbuddy.com/api/v1/countries
// only returns one?

// get dealers
// https://pyzeleurope.shaperbuddy.com/api/v1/dealers

//pyzel.dealers.get_countries();
pyzel.dealers = {

	map: '',

	default: ()=>{

		pyzel.dealers.init_map();

		let countries_loaded = [];
		let states_loaded = [];	

		let country_safe_name = '';

		$.ajax({

			url: endpoint+'/dealers',
			method: 'get'

		}).done( r => {

			let loops = 0;

			pyzel.dealers.set_markers( r );

			// populate countries array
			$.each( r, ( k, i ) => {							

				let dealers_html = '';
				let dealer_html = '';

				country_safe_name = pyzel.helpers.safe_name( i.country );

				//console.log( i.gpslat );
				//console.log( i.gpslong );			

				if( $.inArray( i.id_country,  countries_loaded ) == -1){	

					$('#country').append($("<option/>", {
		        		value: pyzel.helpers.safe_name( i.country ),
		        		text: i.country
		    		}));

					//------------------------------------------------
					// append countries
					dealers_html = `

						<div class="country container clearfix">

							<div class="row" id="row-country-${ i.id_country }">

								<div class="col-sm-12" id="${ country_safe_name }">
									
									<h2>${ i.country }</h2>

									<div id="country-${ i.id_country }-placeholder"></div>
									
								</div>

							</div>	

						</div>	

					`;

					$('#dealers-placeholder').append( dealers_html );

					countries_loaded.push( i.id_country );											

				}

				//----------------------------------------------------
				// append states
				if( i.id_state != '' && $.inArray( i.id_state,  states_loaded ) == -1 ){											

					//console.log( i.id_country )
					//console.log( i.id_state );

					$('#row-country-'+i.id_country ).append(
						`<div class="col-sm-12">
							<h3 id="header-state-${ i.id_state }">
								${ i.state }
							</h3>
							<div id="state-${ i.id_state }-placeholder"></div>
						</div>`
					);

					states_loaded.push( i.id_state );

				}

				//----------------------------------------------------
				// build dealer html - no matter if state or country

				dealer_html = `

					<div class="col-sm-4 col-md-3 dealer-details">							

						<div class="name">
							
							${ i.name }

						</div>

						<div class="address">
						
							${ i.address }, ${ i.state }, ${ i.zipcode } 							

						</div>
						
						<a href="${ i.online }" class="link" target="_blank">
							
							${ i.online }

						</a>
						
						<div class="maps">

							<a href="#" class="trigger-item" data-id-shop="${ i.id_shop }">

								View on Google Maps

							</a>	

						</div>

					</div>`;				

				//----------------------------------------------------
				// append store to state, if state exists

				if( i.id_state != '' ){
											
					$('#state-'+i.id_state+'-placeholder').append( dealer_html );

				}else{

				//----------------------------------------------------
				// append store to country

					$('#country-'+i.id_country+'-placeholder').append( dealer_html );

				}

			})

			//console.log('ajax ended.');

			// trigger location change
			if( window.location.hash ){

				//console.log( 'we have hash: '+window.location.hash );

				let country = window.location.hash.replace('#','');

				$('#country').val( country );

				$('#country-selector').trigger('click');

			}			

		}) // end ajax

		//------------------------------------------------------------
		// handle the select coutry
		//$('#country-selector').on('click', e =>{

		$('#country').on('change', ( e )=>{

		//	$('#country-form').submit();

		//})			

			e.preventDefault();

			console.log( $('#country').val() );	

			let country_safe_name = pyzel.helpers.safe_name( $('#country').val() );	

			let el = $('#'+country_safe_name );

			//console.log( el );

			//window.location.hash = '#'+country_safe_name;
			
			$("body").stop().animate({ scrollTop: el.offset().top - 200 }, 2000, function() { 
			
				//console.log('finished animation');
				//window.location.hash = '#'+country_safe_name;

			});			

		});	

	},


	// set markers - based on old code

	set_markers: ( stores ) =>{		

	    //console.log( stores );

	    let markers_array = [];

		var infowindow = new google.maps.InfoWindow();
		var marker, i;
		/*
		var image = {
	    	url: 'images/chilli_mapmarker.png'
	    }
	    */
	    
		$( document ).on('click', '.trigger-item', e =>{

			e.preventDefault();

			let id_shop = $(e.target).data('id-shop');

			console.log('trigger-item clicked');
			google.maps.event.trigger( markers_array[ id_shop ], 'click');

			$("body").stop().animate({ scrollTop: 0 }, 500, function() { 
			

			});				

		});

		$.each( stores, ( k , i ) =>{

			marker = new google.maps.Marker({
				position: new google.maps.LatLng( i.gpslat, i.gpslong ),
				map: pyzel.dealers.map
			});		

			markers_array[i.id_shop] = marker;		

			google.maps.event.addListener(marker, 'click', (function(marker, i) {

	          //------------------------------------------------------------------------------------------------------------
	          // build info content
	          var info_content = '<div class="maps-info-content">';

	          // place a image here.. <img src="/assets/img/favicons/favicon-32x32.png">
	          info_content += '<h1>'+i.name+'</h1>';

	          if( i.address != '' )
	              info_content += i.address;

	          if( i.phone != '' )
	              info_content += '<br>ph: '+i.phone;

	          if( i.email != '' )
	              info_content += '<br><a href="mailto:'+i.email+'">'+i.email+'</a>';

	          if( i.online != '' )
	              info_content += '<br><a href="'+i.online+'" target="_blank">'+i.online+'</a>';

	          info_content += '</div>';

	          //------------------------------------------------------------------------------------------------------------

		    return function() {

	            infowindow.setContent(

	                info_content

	            );

	            infowindow.open( pyzel.dealers.map, marker);

	            pyzel.dealers.map.panTo(this.getPosition());

	            pyzel.dealers.map.setZoom(14);	           


		    }

		  })(marker, i));

		//}

		})

		var markers = new Array();

		// optimize this..
		var locationsSize = stores.length;
		
		for( var i = 0; i < locationsSize; i++ ){

			markers.push(new google.maps.LatLng ( stores[i].gpslat, stores[i].gpslong));

		}

		var bounds = new google.maps.LatLngBounds();
		
		for( i = 0; i < markers.length; i++ ) {

			bounds.extend(markers[i]);

		}

		pyzel.dealers.map.fitBounds( bounds );
		
	    $( window ).on('resize', function(){

	        pyzel.dealers.map.fitBounds(bounds);	        

	    })		    

	},	

	init_map: ()=>{		
		
		pyzel.dealers.map = new google.maps.Map(document.getElementById('dealers-map'), {
	        zoom: 2,
	        center: new google.maps.LatLng(-33.92, 151.25),
	        mapTypeId: google.maps.MapTypeId.ROADMAP,
	        scrollwheel: false
		});						

	}
	
}				
pyzel.worldwide = {

    map_links: $(

        ()=>{

            //alert();
            $('.maps a').on('click', ( e )=>{

                e.preventDefault();

                //console.log( $( e.target ).data('gps') );

                let shop_name = $( e.target ).data('shop-name');
                //let gps = $( e.target ).data('gps');
                //let gps_lat = Number( $( e.target ).data('gps_lat') );
                //let gps_long = Number( $( e.target ).data('gps_long') );

                let gps_lat = Number( $( e.target ).data('gps-lat') );
                let gps_long = Number( $( e.target ).data('gps-long') );

                let address = $( e.target ).data('address');

                //console.log( gps_lat );
                //console.log( gps_long );

                /*
                let modal = `

                    <div class="modal" tabindex="-1" role="dialog" id="maps-modal">

                        <div class="modal-dialog" role="document">

                            <div class="modal-content">

                                <div class="modal-header">

                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>

                                    <h4 class="modal-title">

                                        Pyzel worldwide - ${ shop_name }

                                    </h4>

                                </div>

                                <div class="modal-body" id="map-placeholder" style="min-height:500px">

                                    <p>One fine body&hellip;</p>

                                </div>

                            </div>

                        </div>

                    </div>                    

                `;
                */

                //$('body').append( modal );

                $('#maps-modal .modal-title').text('Pyzel worldwide - '+shop_name);

                $('#maps-modal #map-address').text( address );

                $('#maps-modal').modal('show');

                let google_lat_long = new google.maps.LatLng( gps_lat, gps_long );

                let map = new google.maps.Map(document.getElementById('map-placeholder'), {

                    zoom: 12,
                    center: google_lat_long ,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false
                    
                });

                let marker = new google.maps.Marker({
                    
                    position: google_lat_long,
                    map: map

                });                                                            

            })

        }

    ),

	send_message: ()=>{	

		$('#send-message-btn').on('click', e =>{
            
            e.preventDefault();                    
            
            let name = $('#send-message-form #name').val();    
            let email = $('#send-message-form #email').val();
            let message = $('#send-message-form #message').val().replace(/(\r\n|\n|\r)/gm,"\\n");
            
            if( name != '' && /(.+)@(.+){2,}\.(.+){2,}/.test( email ) ){

                $.ajax({

                    url: endpoint+'/contacts',
                    method: 'post',
                    contentType: 'application/json',
                    dataType: 'json',            
                    data: JSON.stringify( {

                        from_name : name, 
                        from_email : email,
                        message : message                

                    } )

                }).done( r => {                    

                    $('#send-message-form input, #send-message-form textarea').fadeOut();

                    $('#send-message-btn').off('click');

                    $('#send-message-btn').html('message sent!').addClass('btn-success disabled');

                }).fail( e => {

                    console.log( e );

                    alert('an error occured while communicating with the server');

                })
                
            }else{
             
                alert('please check invalid fields');
                
                // add some visual feedback - not defined on the design
                //$('#subscribe-newsletter-form #email').parent('.form-group').addClass('has-error');
                
            }        
            
        })		

	}

}